import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class TimezoneService {
	
	private timezones$?: Observable<TimezoneModel[]>;
	
	constructor(
		private http: HttpClient
	) {}
	
	getTimezones() {
		if (this.timezones$) return this.timezones$;
		return this.timezones$ = this.http.get<TimezoneModel[]>('/api/timezones').pipe(
			shareReplay(1)
		)
	}
	
	getTimezoneById(timezoneId: string) {
		return this.http.get<TimezoneModel>('/api/timezones', { params: { timezoneId } });
	}
}

export interface TimezoneModel {
	id: string;
	displayName: string;
	offset: number;
	inDaylightSavings: boolean;
	observesDaylightSavings: boolean;
}